let rfpDetail = null;
let proposalDetail = null;
let bidderSectionToggle = {
  accredited: true,
  nonAccredited: false,
  biddersInfo: false
};
let proposalDetailIds = {
  id: '',
  rfpId: '',
  corporateId: '',
  rfpDetail: null
};

let fileSectionFromTemplate = [];
let fileSectionProposalTemplate = [];

export const putFileSectionProposalFromTemplate = (obj) => {
  fileSectionProposalTemplate = obj;
};

export const getFileSectionProposalFromTemplate = () => {
  return fileSectionProposalTemplate;
};

export const emptyFileSectionProposalFromTemplate = () => {
  fileSectionProposalTemplate = [];
};

export const putFileSectionFromTemplate = (obj) => {
  fileSectionFromTemplate = obj;
};

export const getFileSectionFromTemplate = () => {
  return fileSectionFromTemplate;
};

export const emptyFileSectionFromTemplate = () => {
  fileSectionFromTemplate = [];
};

export const putRfpDetail = (obj) => {
  rfpDetail = obj;
};

export const getRfpDetail = () => {
  return rfpDetail;
};

export const emptyRfpDetail = () => {
  rfpDetail = null;
};

export const putProposalDetail = (obj) => {
  proposalDetail = obj;
};

export const getProposalDetail = () => {
  return proposalDetail;
};

export const emptyProposalDetail = () => {
  proposalDetail = null;
};

export const putBidderToggle = (obj) => {
  bidderSectionToggle = obj;
};

export const getBidderToggle = () => {
  return bidderSectionToggle;
};

export const resetBidderToggle = () => {
  bidderSectionToggle = {
    accredited: true,
    nonAccredited: false,
    biddersInfo: false
  };
};

export const putProposalDetailIds = (obj) => {
  proposalDetailIds = obj;
};

export const getProposalDetailIds = () => {
  return proposalDetailIds;
};

export const resetProposalDetailIds = () => {
  proposalDetailIds = {
    id: '',
    rfpId: '',
    corporateId: '',
    rfpDetail: null
  };
};
